// Task sheet issue statuses. REJECTED: an approver declined a manager's
// solution and the manager hasn't resubmitted yet; resubmitting puts the issue
// back to PENDING (awaiting approval). Both are still open.
export const STATUS_COLORS = {
  PENDING: "#f08c00",
  REJECTED: "#e03131",
  RESOLVED: "#2f9344",
};

export const isOpenIssue = (status) =>
  status === "PENDING" || status === "REJECTED";

// Style for a status label: REJECTED stands out as a red badge, the others
// are plain coloured text
export const statusStyle = (status) => ({
  color: STATUS_COLORS[status],
  ...(status === "REJECTED" && {
    display: "inline-block",
    padding: "2px 8px",
    borderRadius: "4px",
    border: `1px solid ${STATUS_COLORS.REJECTED}`,
    backgroundColor: "#ffe3e3",
    fontWeight: 700,
  }),
});
